import Vue from "vue";
import VueRouter from "vue-router";
//Vistas Publicas

import IndexFondef from "../views/people-fondef/Index.vue";
import ComposicionFondef from "../views/people-fondef/Composicion.vue";
import DotacionFondef from "../views/people-fondef/Dotacion.vue";
import RemuneracionesFondef from "../views/people-fondef/Remuneraciones.vue";
import LongevidadFondef from "../views/people-fondef/Longevidad.vue";
import PersonasFondef from "../views/people-fondef/Personas.vue";
import MinsalFondef from "../views/people-fondef/Minsal.vue";
import DatosFondef from "../views/people-fondef/Datos.vue";
import MinisteriosFondef from "../views/people-fondef/Ministerios.vue";

import Home from "../views/Home.vue";
import Login from "../views/auth/Login.vue";
import People from "../views/people/People.vue";
import Ejecucion from "../views/ejecucionPresupuestaria/Ejecucion";
import Instituciones from "../views/institutions/Institutions.vue";
import InstitutionsByMinistry from "../views/institutionsByMinistry/ServicesByMinisID.vue";
import RHumanos from "../views/recursos-humanos/RHumanos";
import RFinanciero from "../views/recursos-financiero/RFinanciero";
import Indicadores from "../views/indicadores/Indicadores";
import AcercaDe from "../views/acerca-de/AcercaDe";
import Comparate from "../views/comparate/Comparate";
import Comparator from "../views/comparator/Comparator.vue";
import ComparateFinanciera from "../views/comparateFinanciero/ComparateFinanciera";
import NotFound from "../views/NotFound/NotFound";
import Callback from "../views/callbackClaveUnica/Callback.vue";
//vistas privadas
//HOE O GESTION.GOB
import Gestion from "../views/gestion/Gestion.vue";
//PORTADAS O VISTA DE TABLAS
import PortadaBgi from "../views/portada/PortadaBgi.vue";
//BOTONES DE ACCESSOS
import Buttons from "../views/desktopButtons/Buttons.vue";
//VISTAS DE PRESENTACION DE MINISTRO
import Ministerio from "../views/presentacion-ministerio/Ministerio.vue";
import MinistroAvance from "../views/avanceDegestion/MinistroAvance";
import PricipalesAutoridades from "../views/pricipalesAutoridades/PricipalesAutoridades";
//VISTAS DE PRESENTACION DE SERVICIOS
import Servicios from "../views/presentacion-servicio/Servicios.vue";
import Somos from "../views/presentacion-servicio-somos/Somos.vue";
//VISTA DE EQUIDAD DE GENERO
import Genero from "../views/genero/Genero.vue";
//LEYES
import Leyes from "../views/leyes/Leyes";
//RESULTADO DE LA GESTION
import ProgramaGobierno from "../views/resultadoGestion/ProgramaGobierno";
import productoEstrategicos from "../views/resultadoGestion/productoEstrategicos";
//HISTORIAL
import Historial from "../views/historial/Historial";
//ANTECEDENTES PARA LA DECLARACION
import Antecedente from "../views/antecedente/Antecedente";
// Comentarios
import Comentario from "../views/comentario/Comentario"
//VISTA DE CONFIGURACION
import Acceso from "../views/acceso/Acceso.vue";
//RECURSOS HUMANOS
import RHumano from "../views/rHumanos/RHumanos";
//DESAFIOS
import Desafios from "../views/desafios/Desafios.vue";
//INDICADORES
import Indicador from "../views/indicador/Indicador";
//COMPROMISOS
import Compromisos from "../views/compromisos/Compromisos";
//EVALUACIONES
import InformePrograma from "../views/evaluaciones/informePrograma/InformePrograma";
import InformePreliminar from "../views/evaluaciones/informesPreliminar/InformePreliminar";
//INCENTIVO INSTITUCIONAL
import IInstitucional from "../views/incentivoInstitucional/IInstitucional";
//ORGANIGRAMA DE SERVICIO
import OServicio from "../views/oServicio/OServicio";
//ORGANIGRAMA DE MINISTRO
import OMinisterio from "../views/oMinisterio/OMinisterio";
//RECURSOS FINANCIEROS
import RFinancieross from "../views/rFinanciero/RFinancieross";
//INCENTIVO COLECTIVO
import IColectivo from "../views/incentivoColectivo/IColectivo";
//PREMIOS Y RECONOCIMIENTO
import Premios from "../views/premios/Premios";

import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/callback/claveunica",
    name: "claveunicaCallback",
    component: Callback,
  },
  {
    path: "/persona-en-el-estado",
    name: "people",
    component: People,
  },
  {
    path: "/recursos-humanos/:id",
    name: "rhumanos",
    component: RHumanos,
  },
  {
    path: "/recursos-financieros/:id",
    name: "rfinancieros",
    component: RFinanciero,
  },
  {
    path: "/Indicadores/:id",
    name: "indicadores",
    component: Indicadores,
  },
  {
    path: "/ejecucion-presupuestaria",
    name: "ejecucion",
    component: Ejecucion,
  },
  {
    path: "/instituciones",
    name: "instituciones",
    component: Instituciones,
  },
  {
    path: "/instituciones/:id",
    name: "instituciones-by-ministry",
    component: InstitutionsByMinistry,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/acerca-de/:id",
    name: "acercade",
    component: AcercaDe,
  },
  {
    path: "/comparate",
    name: "comparate",
    component: Comparate,
  },
  {
    path: "/comparator",
    name: "comparator",
    component: Comparator,
  },
  {
    path: "/comparate-financiera",
    name: "ComparateFinanciera",
    component: ComparateFinanciera,
  },
  // VISTAS DE ADMINISTRADOR

  // VISTA DE HOME ADMINISTRATIVO
  {
    path: "/gestion",
    name: "gestion",
    component: Gestion,
    meta: { autenticado: true },
  },
  //PORTADAS O VISTA DE TABLAS
  {
    path: "/:idUsuario/portada-bgi",
    name: "bgi",
    component: PortadaBgi,
    meta: { autenticado: true },
  },
  {
    path: "/:idUsuario/:idServicio/escritorio-de-gestion-virtual",
    name: "buttons",
    component: Buttons,
    meta: { autenticado: true },
  },

  //VISTAS DE PRESENTACION DE SERVICIOS
  {
    path:
      "/escritorio-de-gestion-virtual/:idServicio/presentacion-de-servicio/resumen",
    name: "servicios",
    component: Servicios,
    meta: { autenticado: true },
  },
  {
    path:
      "/escritorio-de-gestion-virtual/:idServicio/presentacion-de-servicio/somos",
    name: "somos",
    component: Somos,
    meta: { autenticado: true },
  },
  {
    path:
      "/escritorio-de-gestion-virtual/:idServicio/presentacion-de-servicio/pricipales-autoridades",
    name: "pricipalesAutoridades",
    component: PricipalesAutoridades,
    meta: { autenticado: true },
  },
  //VISTAS DE PRESENTACION DE MINISTRO
  {
    path:
      "/escritorio-de-gestion-virtual/:idServicio/presentacion-del-ministro",
    name: "ministerio",
    component: Ministerio,
    meta: { autenticado: true },
  },
  {
    path:
      "/escritorio-de-gestion-virtual/:idServicio/presentacion-del-ministro/avance-de-la-gestion",
    name: "ministroAvance",
    component: MinistroAvance,
    meta: { autenticado: true },
  },
  //VISTA DE EQUIDAD DE GENERO
  {
    path: "/escritorio-de-gestion-virtual/:idServicio/equidad-de-genero",
    name: "genero",
    component: Genero,
    meta: { autenticado: true },
  },
  //VISTA DE CONFIGURACION
  {
    path: "/:idUsuario/:idServicio/portada-bgi/configuraciones",
    name: "acceso",
    component: Acceso,
    meta: { autenticado: true },
  },
  {
    path: "/:idUsuario/:idServicio/portada-bgi/configuraciones/admin",
    name: "accesoAdmin",
    component: Acceso,
    meta: { autenticado: true },
  },
  //RESULTADO DE LA GESTION
  {
    path:
      "/portada-bgi/:idServicio/resultado-de-la-gestion/programa-de-gobierno",
    name: "programaGobierno",
    component: ProgramaGobierno,
    meta: { autenticado: true },
  },

  {
    path:
      "/portada-bgi/:idServicio/resultado-de-la-gestion/resultado-de-productos-estrategicos",
    name: "productoEstrategicos",
    component: productoEstrategicos,
    meta: { autenticado: true },
  },
  //HISTORIAL
  {
    path: "/portada-bgi/historial",
    name: "historial",
    component: Historial,
    meta: { autenticado: true },
  },
  //Antecedente
  {
    path: "/portada-bgi/antecedente-para-la-declaracion",
    name: "antecedente",
    component: Antecedente,
    meta: { autenticado: true },
  },
  // Comentarios
  {
    path: "/comentarios",
    name: "comentario",
    component: Comentario,
    meta: { autenticado: true },
  },
  //LEYES
  {
    path: "/portada-bgi/:idServicio/leyes/en-tramite",
    name: "leyesTramite",
    component: Leyes,
    meta: { autenticado: true },
  },
  {
    path: "/portada-bgi/:idServicio/leyes/promulgadas",
    name: "leyesPromulgadas",
    component: Leyes,
    meta: { autenticado: true },
  },
  //RECURSOS HUMANOS
  {
    path: "/portada-bgi/:idServicio/recursos-humanos",
    name: "rHumanos",
    component: RHumano,
    meta: { autenticado: true },
  },
  //DESAFIOS
  {
    path: "/portada-bgi/:idServicio/desafios",
    name: "desafio",
    component: Desafios,
    meta: { autenticado: true },
  },
  //INDICADOR
  {
    path: "/portada-bgi/:idServicio/indicador",
    name: "indicador",
    component: Indicador,
    meta: { autenticado: true },
  },
  //COMPROMISOS
  {
    path: "/portada-bgi/:idServicio/compromisos",
    name: "compromisos",
    component: Compromisos,
    meta: { autenticado: true },
  },
  //EVALUACIONES
  {
    path: "/portada-bgi/:idServicio/evaluaciones-informe-programa",
    name: "informeprograma",
    component: InformePrograma,
    meta: { autenticado: true },
  },
  {
    path: "/portada-bgi/:idServicio/evaluaciones-informe-preliminar",
    name: "informepreliminar",
    component: InformePreliminar,
    meta: { autenticado: true },
  },
  //INCENTIVO INSTITUCIONAL
  {
    path: "/portada-bgi/:idServicio/incentivo-institucional",
    name: "iinstitucional",
    component: IInstitucional,
    meta: { autenticado: true },
  },
  //ORGANIGRAMA DE SERVICIO
  {
    path: "/portada-bgi/:idServicio/organigrama-servicio",
    name: "oservicio",
    component: OServicio,
    meta: { autenticado: true },
  },
  //ORGANIGRAMA DE MINISTERIO
  {
    path: "/portada-bgi/:idServicio/organigrama-ministro",
    name: "oministerio",
    component: OMinisterio,
    meta: { autenticado: true },
  },
  //RECURSOS-FINANCIEROS
  {
    path: "/portada-bgi/:idServicio/recursos-financieros",
    name: "rfinancieross",
    component: RFinancieross,
    meta: { autenticado: true },
  },
  //INCENTIVO cOLECTIVO
  {
    path: "/portada-bgi/:idServicio/incentivo-colectivo",
    name: "icolectivo",
    component: IColectivo,
    meta: { autenticado: true },
  },
  //PREMIOS Y RECONOCIMIENTO
  {
    path: "/portada-bgi/:idServicio/premios-y-reconocimientos",
    name: "premios",
    component: Premios,
    meta: { autenticado: true },
  },





  {
    path: "/min-hacienda/persona-en-el-estado/fondef",
    name: "fondef-index",
    component: IndexFondef
  },
  {
    path: "/min-hacienda/persona-en-el-estado/fondef/composicion",
    name: "fondef-composicion",
    component: ComposicionFondef
  },
  {
    path: "/min-hacienda/persona-en-el-estado/fondef/dotacion",
    name: "fondef-dotacion",
    component: DotacionFondef
  },
  {
    path: "/min-hacienda/persona-en-el-estado/fondef/remuneraciones",
    name: "fondef-remuneraciones",
    component: RemuneracionesFondef
  },
  {
    path: "/min-hacienda/persona-en-el-estado/fondef/longevidad",
    name: "fondef-longevidad",
    component: LongevidadFondef
  },
  {
    path: "/min-hacienda/persona-en-el-estado/fondef/personas",
    name: "fondef-personas",
    component: PersonasFondef
  },
  {
    path: "/min-hacienda/persona-en-el-estado/fondef/minsal",
    name: "fondef-minsal",
    component: MinsalFondef
  },
  {
    path: "/min-hacienda/persona-en-el-estado/fondef/ministerios",
    name: "fondef-ministerios",
    component: MinisteriosFondef
  },
  {
    path: "/min-hacienda/persona-en-el-estado/fondef/datos",
    name: "fondef-datos",
    component: DatosFondef
  },

  // RUTAS DE 404
  {
    path: "/404",
    name: "notfound",
    component: NotFound,
  },
  {
    path: "/*",
    component: NotFound,
  },



];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // console.log(to);
  if (to.matched.some((record) => record.meta.autenticado)) {
    if (store.state.sesion.user && store.state.sesion.usuario ) {
  
      next();
    } else {
      next({ name: "login" });
    }
  } else {
    next();
  }
});

export default router;
